// extracted by mini-css-extract-plugin
module.exports = {"room":"NotebookOverview_room__3V3ll","roomName":"NotebookOverview_roomName__3R456","user":"NotebookOverview_user__3Y94_","notebookList":"NotebookOverview_notebookList__13iYU"};